<template>
  <div class="JiuZuoMuyuan">
    <div class="wrap">
      <!-- <BaseTitle :titleText="titleText" :subText="subText" /> -->
      <BaseItem :instance="el" v-for="(el, i) in pageData" :key="i"></BaseItem>
    </div>
  </div>
</template>

<script>
import BaseItem from '@/views/JiuZuoMuyuan/BaseItem'
import { queryCemetery } from '@/api/http/index.js'
import { imgUrl } from '@/api/http/baseURL.js'
import { _updatePages } from '@/utils/tool.js'

export default {
  name: 'JiuZuoMuyuan',
  data() {
    return {
      titleText: '九座墓园',
      subText: '楚王墓群',
      pageData: []
      // navList: []
    }
  },
  created() {},
  mounted() {
    //  拿到小程序页面栈数量
    _updatePages(this.$route.fullPath)

    this.queryPageData()

    this.$EventBus.$on('backIndex', index => {
      const domList = document.getElementsByClassName('BaseItem')
      domList[index].scrollIntoView()
    })
  },
  beforeDestroy() {
    this.$EventBus.$off('backIndex')
  },
  components: {
    BaseItem
  },
  computed: {},
  methods: {
    // 请求数据
    queryPageData() {
      this.$EventBus.$emit('loadEvent', true)
      queryCemetery('FuneraryPark').then(
        res => {
          this.$EventBus.$emit('loadEvent', false)
          if (res) {
            const navList = []
            res.forEach(el => {
              el.files.forEach(el2 => {
                let path = el2.filePath
                el2.sourcePath = path
                el2.filePath = imgUrl + el2.filePath
                el2.properties = el.properties
              })
              el.files = el.files.filter(x => x.materialCategory === 'FILE_TYPE_PICTURE')
              navList.push({ label: el.instanceName })
            })
            this.pageData = res
            const params = {
              label: '楚王墓群',
              subLabel: '九座墓园',
              subNav: navList
            }
            this.$EventBus.$emit('injectNav', params)
          }
        },
        () => {
          this.$EventBus.$emit('loadEvent', false)
          this.$notify({
            duration: 3000,
            position: 'top-left',
            title: '提示',
            customClass: 'relationClass',
            message: '网络错误'
          })
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.JiuZuoMuyuan {
  overflow: hidden;

  width: 100%;
  height: 100%;

  .wrap {
    position: relative;
    z-index: 999;

    overflow-y: scroll;

    width: inherit;
    height: inherit;
    padding-top: 1.5rem;
    padding-bottom: 0.7rem;
  }
}
</style>